import { NgModule } from "@angular/core";
import { ValidationComponent } from "./validation.component";
import { CommonModule } from "@angular/common";

@NgModule({
  declarations: [ValidationComponent],
  imports: [CommonModule],
  exports: [ValidationComponent]
})
export class ValidationModule {}
